import React from "react";
import { DownloadFileProps } from "~/file-loading/useDownloadFile";
import { ImagePreviewActions } from "~/image-preview/ImagePreviewActions";
import { Employee } from "~/gql/types";

export type ReceiptTypeExpense = {
  __typename: "FuelExpense" | "ReceiptValuedExpense" | "PerDiemExpense";
  employee: Employee;
  date: string;
  receiptImageUrl?: string;
  fuelReceiptUrl?: string;
  perDiemReceiptUrl?: string;
  receiptImageId?: string;
  fuelReceiptId?: string;
  perDiemReceiptId?: string;
};

export type ReceiptHandlerProps = {
  expense: ReceiptTypeExpense;
  mockDownloader?: (args: DownloadFileProps) => void;
};

const imageUrlMap = (expense: ReceiptTypeExpense): string => {
  const map = {
    FuelExpense: expense.fuelReceiptUrl!,
    ReceiptValuedExpense: expense.receiptImageUrl!,
    PerDiemExpense: expense.perDiemReceiptUrl!,
  };
  return map[expense.__typename];
};

export const ReceiptActions: React.FC<ReceiptHandlerProps> = ({
  expense,
  mockDownloader,
}) => {
  const imageUrl = imageUrlMap(expense);
  const filename = `${expense.employee.lastName}-${expense.employee.firstName}-${expense.date}-${expense.__typename}`;

  return (
    <ImagePreviewActions
      imageUrl={imageUrl}
      filename={filename}
      mockDownloader={mockDownloader}
    />
  );
};
